import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putControlTask } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_TASKS.PUT,
  api: putControlTask,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/controlTasks/PutAction.js